"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useWindowWidth = exports.useWindowHeight = exports.useWindowSize = exports.useWindowScrollAtTop = exports.useElementScrollPosition = exports.useWindowScrollPosition = exports.useMutationObserver = exports.Tooltip = exports.TextInput = exports.TextInfo = exports.TextArea = exports.Paragraph = exports.Text = exports.Tabs = exports.Sticker = exports.Radio = exports.Price = exports.PopupManager = exports.modalResponse = exports.ModalFooter = exports.Modal = exports.LanguageSelect = exports.Logo = exports.Loader = exports.List = exports.Link = exports.InfoMessage = exports.UserMenu = exports.MainMenuMobile = exports.HeaderUserMenu = exports.HeaderButton = exports.DesktopMenu = exports.Header = exports.Footer = exports.Flex = exports.DropDown = exports.Divider = exports.ContextMenu = exports.Checkbox = exports.Card = exports.Button = exports.Accordion = exports.device = exports.space = exports.margin = exports.padding = exports.font = exports.fontSize = exports.color = exports.breakpoints = void 0;
exports.handleSize = exports.handleUtility = exports.H4 = exports.H3 = exports.H2 = exports.H1 = exports.BigTitle = exports.Device = exports.useIsTablet = exports.useIsMobile = exports.useIsDevice = exports.useIsDesktop = void 0;
require("./global.css");
require("tele2-core-styles/main.css");
var Accordion_1 = __importDefault(require("./Accordion/Accordion"));
exports.Accordion = Accordion_1.default;
var Button_1 = __importDefault(require("./Button/Button"));
exports.Button = Button_1.default;
var Card_1 = __importDefault(require("./Card/Card"));
exports.Card = Card_1.default;
var Checkbox_1 = __importDefault(require("./Checkbox/Checkbox"));
exports.Checkbox = Checkbox_1.default;
var Divider_1 = __importDefault(require("./Divider/Divider"));
exports.Divider = Divider_1.default;
var ContextMenu_1 = __importDefault(require("./ContextMenu/ContextMenu"));
exports.ContextMenu = ContextMenu_1.default;
var DropDown_1 = __importDefault(require("./DropDown/DropDown"));
exports.DropDown = DropDown_1.default;
var Flex_1 = __importDefault(require("./Flex/Flex"));
exports.Flex = Flex_1.default;
var Footer_1 = __importDefault(require("./Footer"));
exports.Footer = Footer_1.default;
var Header_1 = __importDefault(require("./Header/Header"));
exports.Header = Header_1.default;
var Components_1 = require("./Header/Components");
Object.defineProperty(exports, "DesktopMenu", { enumerable: true, get: function () { return Components_1.DesktopMenu; } });
Object.defineProperty(exports, "HeaderButton", { enumerable: true, get: function () { return Components_1.HeaderButton; } });
Object.defineProperty(exports, "HeaderUserMenu", { enumerable: true, get: function () { return Components_1.HeaderUserMenu; } });
Object.defineProperty(exports, "MainMenuMobile", { enumerable: true, get: function () { return Components_1.MainMenuMobile; } });
Object.defineProperty(exports, "UserMenu", { enumerable: true, get: function () { return Components_1.UserMenu; } });
var InfoMessage_1 = __importDefault(require("./InfoMessage/InfoMessage"));
exports.InfoMessage = InfoMessage_1.default;
var Link_1 = __importDefault(require("./Link/Link"));
exports.Link = Link_1.default;
var List_1 = __importDefault(require("./List/List"));
exports.List = List_1.default;
var Loader_1 = __importDefault(require("./Loader"));
exports.Loader = Loader_1.default;
var Logo_1 = __importDefault(require("./Logo"));
exports.Logo = Logo_1.default;
var LanguageSelect_1 = __importDefault(require("./LanguageSelect"));
exports.LanguageSelect = LanguageSelect_1.default;
var Modal_1 = __importDefault(require("./Modal/Modal"));
exports.Modal = Modal_1.default;
var ModalFooter_1 = __importDefault(require("./Modal/ModalFooter"));
exports.ModalFooter = ModalFooter_1.default;
var modalResponse_1 = __importDefault(require("./Modal/modalResponse"));
exports.modalResponse = modalResponse_1.default;
var PopupManager_1 = __importDefault(require("./PopupManager/PopupManager"));
exports.PopupManager = PopupManager_1.default;
var Price_1 = __importDefault(require("./Price/Price"));
exports.Price = Price_1.default;
var Radio_1 = __importDefault(require("./Radio/Radio"));
exports.Radio = Radio_1.default;
var Sticker_1 = __importDefault(require("./Sticker/Sticker"));
exports.Sticker = Sticker_1.default;
var Tabs_1 = __importDefault(require("./Tabs/Tabs"));
exports.Tabs = Tabs_1.default;
var Text_1 = require("./Text/Text");
Object.defineProperty(exports, "Text", { enumerable: true, get: function () { return Text_1.Text; } });
Object.defineProperty(exports, "Paragraph", { enumerable: true, get: function () { return Text_1.Paragraph; } });
var TextArea_1 = __importDefault(require("./TextArea/TextArea"));
exports.TextArea = TextArea_1.default;
var TextInfo_1 = __importDefault(require("./TextInfo/TextInfo"));
exports.TextInfo = TextInfo_1.default;
var TextInput_1 = __importDefault(require("./TextInput/TextInput"));
exports.TextInput = TextInput_1.default;
var Tooltip_1 = __importDefault(require("./Tooltip/Tooltip"));
exports.Tooltip = Tooltip_1.default;
var Typography_1 = require("./Typography/Typography");
Object.defineProperty(exports, "BigTitle", { enumerable: true, get: function () { return Typography_1.BigTitle; } });
Object.defineProperty(exports, "H1", { enumerable: true, get: function () { return Typography_1.H1; } });
Object.defineProperty(exports, "H2", { enumerable: true, get: function () { return Typography_1.H2; } });
Object.defineProperty(exports, "H3", { enumerable: true, get: function () { return Typography_1.H3; } });
Object.defineProperty(exports, "H4", { enumerable: true, get: function () { return Typography_1.H4; } });
var useMutationObserver_1 = __importDefault(require("./Hooks/useMutationObserver"));
exports.useMutationObserver = useMutationObserver_1.default;
var useScrollPosition_1 = require("./Hooks/useScrollPosition");
Object.defineProperty(exports, "useWindowScrollPosition", { enumerable: true, get: function () { return useScrollPosition_1.useWindowScrollPosition; } });
Object.defineProperty(exports, "useWindowScrollAtTop", { enumerable: true, get: function () { return useScrollPosition_1.useWindowScrollAtTop; } });
Object.defineProperty(exports, "useElementScrollPosition", { enumerable: true, get: function () { return useScrollPosition_1.useElementScrollPosition; } });
var useWindowSize_1 = require("./Hooks/useWindowSize");
Object.defineProperty(exports, "useWindowSize", { enumerable: true, get: function () { return useWindowSize_1.useWindowSize; } });
Object.defineProperty(exports, "useWindowHeight", { enumerable: true, get: function () { return useWindowSize_1.useWindowHeight; } });
Object.defineProperty(exports, "useWindowWidth", { enumerable: true, get: function () { return useWindowSize_1.useWindowWidth; } });
Object.defineProperty(exports, "useIsDesktop", { enumerable: true, get: function () { return useWindowSize_1.useIsDesktop; } });
Object.defineProperty(exports, "useIsDevice", { enumerable: true, get: function () { return useWindowSize_1.useIsDevice; } });
Object.defineProperty(exports, "useIsMobile", { enumerable: true, get: function () { return useWindowSize_1.useIsMobile; } });
Object.defineProperty(exports, "useIsTablet", { enumerable: true, get: function () { return useWindowSize_1.useIsTablet; } });
Object.defineProperty(exports, "Device", { enumerable: true, get: function () { return useWindowSize_1.Device; } });
var Breakpoints_1 = __importDefault(require("./Variables/Breakpoints"));
exports.breakpoints = Breakpoints_1.default;
var Color_1 = __importDefault(require("./Variables/Color"));
exports.color = Color_1.default;
var Font_1 = require("./Variables/Font");
Object.defineProperty(exports, "font", { enumerable: true, get: function () { return Font_1.font; } });
Object.defineProperty(exports, "fontSize", { enumerable: true, get: function () { return Font_1.fontSize; } });
var Padding_1 = __importDefault(require("./Variables/Padding"));
exports.padding = Padding_1.default;
var Margin_1 = __importDefault(require("./Variables/Margin"));
exports.margin = Margin_1.default;
var Space_1 = __importDefault(require("./Variables/Space"));
exports.space = Space_1.default;
var Device_1 = __importDefault(require("./Variables/Device"));
exports.device = Device_1.default;
var Utility_1 = require("./Utility");
Object.defineProperty(exports, "handleSize", { enumerable: true, get: function () { return Utility_1.handleSize; } });
Object.defineProperty(exports, "handleUtility", { enumerable: true, get: function () { return Utility_1.handleUtility; } });
